export function normalizeColor(color, defaultColor) {
    if (!color) return defaultColor;
    return color.startsWith('#') ? color : `#${color}`;
}
